/* global googletag, deployads, bindEvent */
import { call, select, put, takeEvery } from 'redux-saga/effects';
import { RESOLUTIONS, DFP } from '../config';
import { MediaQuery as MQ } from '../media-query';
import moment from 'moment';

function* init() {
    const initialized = yield select(state => state.dfp.initialized);

    if (!initialized) {
        const node = document.getElementsByTagName('script')[0];
        const useSSL = document.location.protocol == 'https:';
        const adtest = window.location.search.match(/__adtest/);

        let gads = document.createElement('script');
        gads.async = true;
        gads.type = 'text/javascript';
        gads.src = `${useSSL ? 'https:' : 'http:'}//www.googletagservices.com/tag/js/gpt.js`;
        node.parentNode.insertBefore(gads, node);

        window.googletag = window.googletag || {};
        window.deployads = window.deployads || [];
        googletag.cmd = googletag.cmd || [];

        let session = yield select(state => state.cookie['dfp-ads']);
        if (session && session.created) {
            const yesterday = moment().subtract(1, 'day');

            if (session.created > yesterday.format('X') && session.pageNumber > 0) {
                session.pageNumber = session.pageNumber + 1;

                yield put({
                    type: 'cookie:set',
                    payload: {
                        name: 'dfp-ads',
                        value: session,
                    },
                });
            }
        } else {
            session = {
                created: moment().unix(),
                pageNumber: 1,
            };

            yield put({
                type: 'cookie:set',
                payload: {
                    name: 'dfp-ads',
                    value: session,
                },
            });
        }

        googletag.cmd.push(() => {
            googletag.pubads().enableSingleRequest();
            googletag.pubads().collapseEmptyDivs();
            window.googletag.pubads().setTargeting('SessionPageNumber', session.pageNumber);
            googletag.pubads().setTargeting('Test', (!!adtest).toString());
            googletag.pubads().setTargeting('URL', window.location.pathname);
            deployads.push(() => {
                deployads.gpt.enableServices();
            });

            const slotRenderEnded = new CustomEvent('slotRenderEnded');
            googletag.pubads().addEventListener('slotRenderEnded', (event) => {
                if (event.isEmpty) {
                    return;
                }

                document.getElementById(event.slot.getSlotElementId()).dispatchEvent(slotRenderEnded);
            });
        });

        bindEvent(window, 'scroll', function() {
            var delay = 6000;
            var dfp = document.querySelector('dfp[name="Top"]');

            if (dfp) {
                var top = dfp.offsetHeight;
                var header = document.querySelector('header');

                if (typeof window.sticky_dfp == 'undefined') {
                    header.style.top = top + 'px';

                    setTimeout(function() {
                        header.style.top = 0;
                        dfp.style.position = 'static';
                        window.sticky_dfp = true;
                    }, delay);
                }
            }
        });

        yield put({
            type: 'dfp:update',
            payload: { initialized: true },
        });
    }
}

function* register({ payload }) {
    const { name, id } = payload;
    let initialized = yield select(state => state.dfp.initialized);
    let doRender = true;

    if (!initialized) {
        yield call(init);
    }

    const session = yield select(state => state.cookie['dfp-ads']); // get session after initialization

    if (name == 'Adhesion') {
        doRender = (
            session
            &&
            session.pageNumber
            &&
            session.pageNumber >= 1
            &&
            session.pageNumber <= 4
            &&
            MQ.isMobile()
        ) ? true : false;
    }

    const sizes = MQ.isMobile() ? DFP.mobile : DFP.desktop;
    if (typeof sizes[name] != 'undefined' && doRender) {
        googletag.cmd.push(() => {
            const mapping = window.googletag.sizeMapping();
            if (MQ.isMobile()) {
                mapping.addSize(RESOLUTIONS.all, sizes[name].all);
            } else {
                Object.keys(RESOLUTIONS).map(key => {
                    mapping.addSize(RESOLUTIONS[key], sizes[name][key]);
                });
            }

            mapping.build();

            const slotName = `/2498354/${MQ.isMobile() ? 'm.tarot.com' : 'tarot.com'}/${name}`;
            const slots = MQ.isMobile() ? sizes[name].all : sizes[name].desktop;
            googletag.defineSlot(slotName, slots, id)
                .defineSizeMapping(mapping)
                .setCollapseEmptyDiv(true)
                .addService(window.googletag.pubads());

            deployads.push(() => {
                deployads.gpt.display(id);
            });
        });

        if (name == 'Adhesion' || name == 'Slider') {
            const dfpDiv = document.getElementById(id);
            dfpDiv.parentNode.classList.add('rendered');
            if (dfpDiv) {
                dfpDiv.addEventListener('slotRenderEnded', () => {
                    // fixes their adhesion, which breaks out of our iframe, and covers our close button
                    setTimeout(() => {
                        const airpushIframe = document.querySelector('iframe[src*="airpush.com"]');

                        if (airpushIframe) {
                            airpushIframe.style.zIndex = 0;
                        }
                    }, 3000);
                });


                if (MQ.isMobile()) {
                    dfpDiv.addEventListener('slotRenderEnded', () => {
                        dfpDiv.style.marginLeft = -(dfpDiv.offsetWidth / 2) + 'px';
                    });
                }
            }

            const dfp = document.querySelector(`dfp[name="${name}"]`);
            if (dfp) {
                dfp.addEventListener('click', () => {
                    dfp.parentNode.removeChild(dfp);
                });
            }
        }
    }
}

export function* root() {
    yield takeEvery('dfp:register', register);
}
